<template>
    <iframe class="responsive-iframe" :src="homeDashboard" frameborder="0" style="border:0" allowfullscreen></iframe>
</template>

<script>
import Vue from "vue";
import { Auth, oAuth } from "../../../classes/Auth";
export default Vue.extend({
  name: "Dashboard9",
  props: {
    source: String,
  },
  data: () => ({
      homeDashboard: '',
      auth: new Auth()
  }),
  mounted(){
    if(this.auth.getProject().name == 'DAVIVIENDA'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/ee921382-bfc5-492d-af19-02bb80215b2d/page/1M"
    }
    if(this.auth.getProject().name == 'DOLLARCITY'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/8af73e99-9d51-4f78-8367-cf0d4cd4d4d1/page/8VcaB"
    }
    if(this.auth.getProject().name == 'DAVIVIENDA II'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/c5d8ad24-c2c2-40f1-9678-70280f273d2f/page/LdbCC"
    }
  }
});
</script>

<style>
.container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>

